import { computed } from 'vue';
import type { HeightmapSaveWarningModalConfig } from '../config';
import { HeightmapCoverageState } from '../enums';

export const useHeightmapSaveWarningModal = (config: HeightmapSaveWarningModalConfig) => {
  const infoHtmlBlockconfig = { key: 'maximap.heightmap.finalize.info' };

  const onConfirm = async (close: () => void) => {
    config.onConfirm?.call(this, assignedParcelIds.value);
    close();
  };

  const onCancel = (close: () => void) => {
    config.onCancel?.call(this);
    close();
  };

  const partiallyCoveredParcels = computed(() =>
    config.parcels
      .filter((p) => p.coverageState === HeightmapCoverageState.PARTIALLY_COVERED)
      .map((p) => p.name)
      .join(', ')
  );

  const uncoveredParcels = computed(() =>
    config.parcels
      .filter((p) => p.coverageState === HeightmapCoverageState.UNCOVERED)
      .map((p) => p.name)
      .join(', ')
  );

  const assignedParcelIds = computed(() =>
    config.parcels
      .filter(
        (p) =>
          p.coverageState === HeightmapCoverageState.COVERED ||
          p.coverageState === HeightmapCoverageState.PARTIALLY_COVERED
      )
      .map((p) => p.id)
  );

  return {
    onConfirm,
    onCancel,
    partiallyCoveredParcels,
    uncoveredParcels,
    infoHtmlBlockconfig
  };
};
